export default __webpack_public_path__ + "static/media/right-rock.292521ab.png";